import { EditAction } from '../shared/enum/EditAction';
export interface CostTimeModel {
    id?: number,
    reach: number | null,
    timePrice: number | null,
    initialTime: string,
    finalTime: string,
    weight?: number,
    editAction: EditAction
}

export const costTimeModelInitial: CostTimeModel = {
    reach: null,
    timePrice: null,
    initialTime: '',
    finalTime: '',
    editAction: EditAction.NONE
};